import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey("Using_this_AG_Grid_Enterprise_key_( AG-043433 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Data Unveil )_is_granted_a_( Single Application )_Developer_License_for_the_application_( SCRAII )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( SCRAII )_need_to_be_licensed___( SCRAII )_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 7 June 2024 )____[v2]_MTcxNzcxNDgwMDAwMA==8211f96f946c59b6a3dfa3ea03a04f25");
import { Component, Input, OnInit, OnDestroy, HostListener, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { forkJoin, Subscription, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { ColDef, GridApi, GridReadyEvent } from "ag-grid-community";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import moment from "moment";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "src/app/services/api.service";
import { SessionService } from "src/app/services/session.service";
import { DialogService } from "src/app/services/dialog.service";
import {
  TaskMgmtService,
  TaskModel,
  SubtaskModel,
} from "src/app/components/direct/service/task-mgmt.service";
import { WorkflowService, FieldOption } from "src/app/components/direct/service/workflow.service";
import { TaskpanelService } from "src/app/components/direct/service/taskpanel.service";
import { SubtaskDropConfirmPayload } from "../../components/subtask-mini-kanban/subtask-mini-kanban.component";
import { TaskManagementDialogComponent } from "src/app/components/direct/components/task-management-dialog/task-management-dialog.component";
import { AvatarCellRendererComponent } from "../../components/cell-renderers/avatar-cell-renderer.component";
import { StatusCellRendererComponent } from "../../components/cell-renderers/status-cell-renderer.component";
import { PriorityCellRendererComponent } from "../../components/cell-renderers/priority-cell-renderer.component";
import { ActionsCellRendererComponent } from "../../components/cell-renderers/actions-cell-renderer.component";
import { SubtaskDrilldownPanelComponent } from "../../components/subtask-drilldown-panel/subtask-drilldown-panel.component";
import { environment } from 'src/environments/environment';

interface KanbanColumn {
  id: string;
  label: string;
  color: string;
  tasks: TaskModel[];
}

@Component({
  selector: "app-task-management-wf",
  templateUrl: "./task-management-wf.component.html",
  styleUrls: ["./task-management-wf.component.scss"],
})
export class TaskManagementWfComponent implements OnInit, OnDestroy {
  @Input() moduleName: string = '';

  /** When true, the board is embedded in the global slide-in sidebar (opened
   *  from e.g. the patient grid) rather than shown as the full page. In this
   *  mode the brand selector is hidden and clicking a main case does NOT open
   *  the subtask sidebar. */
  @Input() sidebarMode: boolean = false;

  /** Tag filter applied to the task list when embedded in the sidebar. Carries
   *  the patient/HCP identifier (`tag_id`) + `tag_category_id` so the board
   *  loads only that entity's cases via `loadTasksByTagFromApi`. `tag_name` is
   *  the display label used to pre-fill the Create-Case dialog's tag chip. */
  @Input() tagContext: { tag_id: any; tag_category_id: any; tag_name?: any } | null = null;

  reqSubcription: Subscription[] = [];

  // --- Toolbar State ---
  currentViewMode: "kanban" | "table" = "kanban";
  viewDropdownOpen = false;

  // --- Brand Dropdown State ---
  brands: any[] = [];
  filteredBrands: any[] = [];
  selectedBrand: any = null;
  brandDropdownOpen = false;
  brandSearchText = '';
  isLoadingBrands = false;

  /** Convenience accessor for wiring the selected brand into API calls later. */
  get selectedBrandKey(): number | null {
    return this.selectedBrand?.brand_key ?? null;
  }

  // --- Kanban Board ---
  kanbanColumns: KanbanColumn[] = [
    { id: "planned", label: "Open", color: "#1363df", tasks: [] },
    { id: "in-progress", label: "In-Progress", color: "#f97316", tasks: [] },
    { id: "done", label: "Completed", color: "#22c55e", tasks: [] },
    { id: "cancelled", label: "Cancelled", color: "#ef4444", tasks: [] },
  ];

  connectedLists: string[] = ["planned", "in-progress", "done", "cancelled"];

  // --- Lookup data loaded from workflow.service (used for drag-drop status updates etc.) ---
  private taskStatuses: FieldOption[] = [];
  private taskPriorities: FieldOption[] = [];
  private taskTypes: FieldOption[] = [];
  /** Raw status objects (`{ task_status_id, status_name, ... }`) from the API,
   *  used by `getColumnForTask` and `getStatusIdForColumn` to derive kanban-column
   *  membership from the real status name. */
  private fullStatusList: any[] = [];

  // --- AG-Grid (Tasks Table) ---
  gridApi!: GridApi;
  columnDefs: ColDef[] = [];
  defaultColDef: ColDef = {
    flex: 1,
    resizable: true,
    sortable: true,
    suppressMenu: true,
  };
  rowData: TaskModel[] = [];
  filteredRowData: TaskModel[] = [];
  getRowId = (params: any): string => String(params.data?.task_id || '');
  frameworkComponents: any;
  searchText = "";
  expandedTask: TaskModel | null = null;

  // --- Subtask sidebar state ---
  sidebarOpen: boolean = false;
  sidebarTask: TaskModel | null = null;
  sidebarSubtasks: SubtaskModel[] = [];
  isLoadingSidebarSubtasks: boolean = false;
  /** True while the background `getTaskByIdFromApi` call is in flight after
   *  the sidebar opened with cached data. Bound to the sidebar's
   *  `[isRefreshing]` input for a subtle refresh indicator. */
  isRefreshingSidebar = false;
  /** Tracks the in-flight sidebar-refresh subscription so rapid open/close
   *  doesn't cause a stale response to overwrite fresh data. */
  private sidebarRefreshSub: Subscription | null = null;

  /** Last task id whose `api/tasks/get-by-id` request is in flight. Used by
   *  refreshAndOpenEditDialog() to ignore stale responses if the user clicks
   *  another task before the previous fetch resolves. */
  private pendingEditTaskId: number | null = null;
  private isCreateDialogOpen = false;
  private isEditDialogOpen = false;

  /** Reference to the slide-in subtask sidebar. The panel is always present in
   *  the template (its visibility is CSS-driven via the `.open` class), so
   *  this reference is stable from the first change-detection cycle. Used to
   *  programmatically trigger the subtask edit dialog when the user clicks a
   *  subtask row inside an expanded table master-detail grid. */
  @ViewChild(SubtaskDrilldownPanelComponent)
  private subtaskPanel?: SubtaskDrilldownPanelComponent;

  // Public lookup options exposed to the sidebar (statusOptions/priorityOptions inputs).
  statusOptions: FieldOption[] = [];
  priorityOptions: FieldOption[] = [];
  taskTypeOptions: FieldOption[] = [];

  /** Tag-category list loaded once from `api/tag-categories/get-all` and
   *  forwarded into the task dialog so the chip selector can render without
   *  a per-dialog fetch. IDs are dynamic (start at 2000 per backend config). */
  tagCategories: any[] = [];
  /** UPPERCASE(category_name) -> tag_category_id. Used by the dialog to
   *  resolve the category id from a tag's `category_name` string when
   *  restoring the chip selection in edit mode. */
  categoryIdCache: Record<string, number> = {};

  /** Flips true after the startup forkJoin (lookups + tasks + subtasks)
   *  completes — successful or fallback. Drives the [disabled] state on
   *  the Create-Task buttons so the dialog never opens before status /
   *  priority / type / category lookups are in place. */
  isStartupComplete = false;

  /** Board-level loading flag. True from first render until the startup
   *  forkJoin resolves (success OR failure). Drives the shared <loading>
   *  overlay in place of the kanban columns / table — otherwise the user
   *  would see an empty board while the tasks request is in flight. */
  isLoadingTasks = true;

  // --- Pagination ---
  paginationPageSize: number = 10;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  currentPage: number = 0;
  totalPages: number = 1;
  visiblePages: (number | string)[] = [1];

  // --- AG-Grid Master-Detail ---
  masterDetail = true;
  detailRowAutoHeight = true;

  // Assigned in the constructor — both depend on `this.taskService` for store reads.
  isRowMaster!: (dataItem: any) => boolean;
  detailCellRendererParams: any;

  private priorityColors: Record<string, { bg: string; border: string; text: string }> = {
    low: { bg: "#dcfce7", border: "#22c55e", text: "#166534" },
    medium: { bg: "#ffedd5", border: "#f97316", text: "#9a3412" },
    high: { bg: "#fee2e2", border: "#ef4444", text: "#991b1b" },
  };

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private sessionService: SessionService,
    private dialogService: DialogService,
    private taskService: TaskMgmtService,
    private workflowService: WorkflowService,
    private tagService: TaskpanelService
  ) {
    this.setupGridColumns();
    this.frameworkComponents = {
      avatarCellRenderer: AvatarCellRendererComponent,
      statusCellRenderer: StatusCellRendererComponent,
      priorityCellRenderer: PriorityCellRendererComponent,
      actionsCellRenderer: ActionsCellRendererComponent,
    };

    // Master-detail wiring — both read from the in-memory all-subtasks store via
    // TaskMgmtService, so they have to be assigned after `taskService` is injected.
    this.isRowMaster = (dataItem: any): boolean => {
      if (!dataItem) return false;
      const numericId = this.toNumericTaskId(dataItem.task_id);
      if (isNaN(numericId)) return false;
      return this.taskService.getSubtaskCountsForParent(numericId).total > 0;
    };

    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {
            headerName: "SUBTASK",
            field: "task_name",
            flex: 2,
            cellStyle: { 'padding-left': '28px' },
          },
          {
            headerName: "STATUS",
            field: "task_status_id",
            flex: 1,
            cellRenderer: 'statusCellRenderer',
            valueGetter: (params: any) =>
              this.taskService.getStatusNameById(params.data?.task_status_id) || '',
          },
          {
            headerName: "PRIORITY",
            field: "task_priority_id",
            flex: 1,
            cellRenderer: 'priorityCellRenderer',
            valueGetter: (params: any) =>
              this.taskService.getPriorityNameById(params.data?.task_priority_id) || '',
          },
          {
            headerName: "ASSIGNED TO",
            field: "assignee_emails",
            flex: 1,
            valueGetter: (params: any) => {
              const d = params.data || {};
              if (Array.isArray(d.assignees) && d.assignees.length) {
                return d.assignees[0]?.assignee_email ?? d.assignees[0]?.email ?? '';
              }
              if (Array.isArray(d.assignee_emails) && d.assignee_emails.length) {
                return d.assignee_emails[0] ?? '';
              }
              return '';
            },
          },
          {
            headerName: "START DATE",
            field: "start_date",
            flex: 1,
            valueFormatter: (params: any) => params.value ? moment(params.value).format("MMM DD, YYYY") : "",
          },
          {
            headerName: "END DATE",
            field: "end_date",
            flex: 1,
            valueFormatter: (params: any) => params.value ? moment(params.value).format("MMM DD, YYYY") : "",
          },
          {
            headerName: '',
            field: 'actions',
            maxWidth: 110,
            minWidth: 110,
            sortable: false,
            suppressMenu: true,
            cellRenderer: 'actionsCellRenderer',
            cellStyle: {
              display: 'flex',
              'align-items': 'center',
              'justify-content': 'center',
              gap: '4px',
            },
          },
        ],
        defaultColDef: { flex: 1, resizable: true, sortable: true, suppressMenu: true },
        frameworkComponents: {
          statusCellRenderer: StatusCellRendererComponent,
          priorityCellRenderer: PriorityCellRendererComponent,
          actionsCellRenderer: ActionsCellRendererComponent,
        },
        context: { componentParent: this },
        rowHeight: 40,
        headerHeight: 36,
        onRowClicked: (event: any) => {
          if (!event?.data) return;
          // Guard: ignore clicks on the actions column (buttons handle themselves).
          const colId = event.column?.getColId?.() ?? event.colDef?.field;
          if (colId === 'actions') return;

          // Row data comes straight from the all-subtasks store, so the raw
          // `parent_task_id` field is present. Use it to locate the parent
          // TaskModel in `rowData` — we need the full parent for the sidebar
          // header (status/priority pills, due date, etc.).
          const parentTaskIdNum = Number(event.data.parent_task_id);
          if (isNaN(parentTaskIdNum)) return;

          const parentTask = this.rowData.find(
            (t) => this.toNumericTaskId(t.task_id) === parentTaskIdNum
          );
          if (!parentTask) return;

          // Open the subtask sidebar for the parent task, then — on the next
          // microtask, once Angular has propagated the `[task]` input binding
          // into the sidebar component — trigger its edit modal with the
          // clicked subtask. setTimeout(0) is enough because the panel is
          // always rendered (no *ngIf), so the ViewChild reference is stable.
          this.openTaskSidebar(parentTask);

          const subtaskModel = this.mapStoreSubtaskToModel(event.data);
          setTimeout(() => {
            this.subtaskPanel?.openSubtaskEditFromExternal(subtaskModel);
          }, 0);
        },
      },
      getDetailRowData: (params: any) => {
        const numericId = this.toNumericTaskId(params.data?.task_id);
        if (isNaN(numericId)) {
          params.successCallback([]);
          return;
        }
        const subtasks = this.taskService.getSubtasksForParent(numericId);
        params.successCallback(subtasks);
      },
    };
  }

  // --------------------------------------------------------
  //  Lifecycle
  // --------------------------------------------------------

  ngOnInit(): void {
    const viewParam = this.route.snapshot.queryParamMap.get('view');
    if (viewParam === 'table' || viewParam === 'kanban') {
      this.currentViewMode = viewParam;
    }

    // Brands load independently of the tasks/subtasks pipeline — they're only
    // used for the toolbar brand selector and don't gate any other data. Skip in
    // sidebar mode, where the brand selector is hidden.
    if (!this.sidebarMode) {
      this.loadBrands();
    }

    // Phase 1: lookups (statuses / priorities / types / assignees) MUST complete
    // before tasks/subtasks load — the task mapper resolves task_status_id →
    // status_name → kanban column id via the loaded list. Phase 2 then runs
    // tasks + subtasks in parallel.
    const startupSub = forkJoin({
      statuses: this.workflowService.getTaskStatuses(),
      priorities: this.workflowService.getTaskPriorities(),
      types: this.workflowService.getTaskTypes(),
      // catchError keeps a tag-category fetch failure from blocking the rest
      // of the startup pipeline — the dialog simply opens with an empty chip
      // group in that case instead of the whole task board failing.
      categories: this.tagService.getTagCategories().pipe(catchError(() => of([]))),
    }).pipe(
      switchMap((lookups) => {
        this.statusOptions = lookups.statuses || [];
        this.priorityOptions = lookups.priorities || [];
        this.taskTypeOptions = lookups.types || [];
        this.taskStatuses = lookups.statuses || [];
        this.taskPriorities = lookups.priorities || [];
        this.taskTypes = lookups.types || [];

        // Unwrap the tag-categories response (tolerates array / {items} / {data}).
        const catResp: any = lookups.categories;
        const catItems: any[] = Array.isArray(catResp)
          ? catResp
          : (Array.isArray(catResp?.items) ? catResp.items
            : (Array.isArray(catResp?.data) ? catResp.data : []));
        this.tagCategories = catItems;
        this.categoryIdCache = {};
        catItems.forEach((c: any) => {
          const key = String(c?.category_name || '').toUpperCase();
          if (key) this.categoryIdCache[key] = c?.tag_category_id;
        });

        // Push the RAW API lookup arrays into the service so its dynamic id<->name
        // resolvers and isDoneStatus / isCancelledStatus checks work against the
        // real data shape (task_status_id + status_name).
        this.fullStatusList = this.workflowService.getRawStatuses();
        this.taskService.setStatusList(this.fullStatusList);
        this.taskService.setPriorityList(this.workflowService.getRawPriorities());
        this.taskService.setTypeList(this.workflowService.getRawTypes());

        // In sidebar mode, load only the cases tagged to the current patient/HCP
        // (filtered get-all). Otherwise load the full, cached task list.
        const tc = this.tagContext;
        const tasks$ =
          this.sidebarMode && tc && tc.tag_id != null
            ? this.taskService.loadTasksByTagFromApi(tc.tag_id, tc.tag_category_id)
            : this.taskService.loadInitialTasks();

        // Sidebar mode is main-case level only — skip the (expensive) all-subtasks
        // API entirely. The store stays empty, so cards show no subcase progress
        // and the table view exposes no master-detail rows.
        const subtasks$ = this.sidebarMode
          ? of([])
          : this.taskService.refreshAllSubtasks();

        return forkJoin({
          tasks: tasks$,
          subtasks: subtasks$,
        });
      })
    ).subscribe({
      next: ({ tasks }) => {
        this.rowData = Array.isArray(tasks) ? tasks : [];
        this.attachSubtaskCounts();
        this.filteredRowData = [...this.rowData];
        this.distributeTasksToColumns();
        this.isStartupComplete = true;
        this.isLoadingTasks = false;
      },
      error: () => {
        this.rowData = [];
        this.filteredRowData = [];
        this.distributeTasksToColumns();
        this.dialogService.openSnackBar('Failed to load case data', 'OK');
        // Unlock the Create buttons even on failure — without this the user
        // would be stuck with disabled controls and no recourse.
        this.isStartupComplete = true;
        // Flip the board loader off as well so the user isn't stranded on a
        // spinner; the empty board + snackbar communicates the failure.
        this.isLoadingTasks = false;
      },
    });
    this.reqSubcription.push(startupSub);

    // Real-time badge updates: when a comment/attachment is added or deleted
    // inside the dialog, the service emits a count event. Update the kanban
    // card / table row immediately without re-fetching from the API.
    const countChangeSub = this.taskService.taskCountChanged$.subscribe(event => {
      this.updateTaskCountInRowData(event);
    });
    this.reqSubcription.push(countChangeSub);

    // Subtask count updates: when a comment/attachment changes on a subtask,
    // re-derive sidebarSubtasks from the store so compact card badges update,
    // AND refresh the AG-Grid detail row so action-cell badges stay current.
    const subtaskCountSub = this.taskService.subtaskCountChanged$.subscribe(event => {
      this.refreshSidebarFromStore();
      // Refresh the parent row's expanded detail grid so subtask action-cell
      // badges reflect the latest counts without a full table reload.
      if (event.parentTaskId != null && this.gridApi) {
        const detailId = 'detail_' + event.parentTaskId;
        const detailGridInfo = this.gridApi.getDetailGridInfo(detailId);
        if (detailGridInfo?.api) {
          const freshSubtasks = this.taskService.getSubtasksForParent(event.parentTaskId);
          detailGridInfo.api.setRowData(freshSubtasks);
        }
      }
    });
    this.reqSubcription.push(subtaskCountSub);
  }

  ngOnDestroy(): void {
    this.gridApi?.destroy();
    this.reqSubcription.forEach((sub) => sub.unsubscribe());
  }

  // --------------------------------------------------------
  //  Toolbar Actions
  // --------------------------------------------------------

  switchViewMode(mode: "kanban" | "table"): void {
    this.currentViewMode = mode;
  }

  toggleViewDropdown(event: Event): void {
    event.stopPropagation();
    this.viewDropdownOpen = !this.viewDropdownOpen;
    this.brandDropdownOpen = false; // mutual exclusion
  }

  selectViewMode(mode: "kanban" | "table"): void {
    this.expandedTask = null;
    this.switchViewMode(mode);
    this.viewDropdownOpen = false;
  }

  // --------------------------------------------------------
  //  Brand Dropdown
  // --------------------------------------------------------

  /** Fetch brands from the dashboard filter API. Called once in ngOnInit.
   *  Auto-selects the first brand if none is already selected. */
  private loadBrands(): void {
    this.isLoadingBrands = true;
    const sub = this.taskService.loadBrands().subscribe({
      next: (response: any) => {
        const allitems = Array.isArray(response) ? response : [];
        const items = environment.typeOfEnv === 'DEMO' ? allitems.filter(x=>x.brand_name === 'Jupiterol') : allitems;        
        this.brands = items;
        this.filteredBrands = [...items];
        this.isLoadingBrands = false;
        if (!this.selectedBrand && items.length > 0) {
          environment.typeOfEnv === 'DEMO' ? this.selectedBrand = items[0] :
          this.selectedBrand = items.find((f: any) => f.brand_key == '200104');
        }
      },
      error: () => {
        this.brands = [];
        this.filteredBrands = [];
        this.isLoadingBrands = false;
      },
    });
    this.reqSubcription.push(sub);
  }

  toggleBrandDropdown(event: Event): void {
    event.stopPropagation();
    this.brandDropdownOpen = !this.brandDropdownOpen;
    this.viewDropdownOpen = false; // mutual exclusion
    if (this.brandDropdownOpen) {
      this.brandSearchText = '';
      this.filteredBrands = [...this.brands];
    }
  }

  onBrandSearch(searchText: string): void {
    this.brandSearchText = searchText;
    if (!searchText.trim()) {
      this.filteredBrands = [...this.brands];
      return;
    }
    const lower = searchText.toLowerCase().trim();
    this.filteredBrands = this.brands.filter(
      (b) => (b.brand_name || '').toLowerCase().includes(lower)
    );
  }

  selectBrand(brand: any): void {
    this.selectedBrand = brand;
    this.brandDropdownOpen = false;
    this.brandSearchText = '';
    this.filteredBrands = [...this.brands];
    // TODO: Wire brand_key into task loading when ready
  }

  @HostListener("document:click")
  onDocumentClick(): void {
    this.viewDropdownOpen = false;
    this.brandDropdownOpen = false;
  }

  // --------------------------------------------------------
  //  Kanban Board
  // --------------------------------------------------------

  distributeTasksToColumns(): void {
    this.kanbanColumns.forEach((col) => (col.tasks = []));

    this.filteredRowData.forEach((task) => {
      const colId = this.getColumnForTask(task);
      const col = this.kanbanColumns.find((c) => c.id === colId);
      if (col) {
        col.tasks.push(task);
      } else {
        this.kanbanColumns[0].tasks.push(task);
      }
    });
  }

  /** Derive the kanban column id for a task from its status NAME (preferred:
   *  `_raw.task_status_name`; fallback: id-to-name lookup via TaskMgmtService). */
  private getColumnForTask(task: any): string {
    const rawName = task?._raw?.task_status_name;
    let statusName = (rawName || '').toLowerCase().trim();
    if (!statusName && task?.status != null && task?.status !== '') {
      const looked = this.taskService.getStatusNameById(Number(task.status));
      statusName = (looked || '').toLowerCase().trim();
    }
    if (statusName === 'open') return 'planned';
    if (statusName === 'in progress' || statusName === 'inprogress' || statusName === 'in-progress') return 'in-progress';
    if (statusName === 'done' || statusName === 'closed' || statusName === 'complete' || statusName === 'completed') return 'done';
    if (statusName === 'cancelled' || statusName === 'canceled') return 'cancelled';
    return 'planned';
  }

  onTaskDrop(event: CdkDragDrop<TaskModel[]>): void {
    // Same-column reorder — no status change
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      return;
    }

    // ----------------------------------------------------------------------
    // PRE-VALIDATION (before any state mutation)
    //
    // Read the dragged task and target column id from the drop event WITHOUT
    // calling transferArrayItem yet. If the move is "to a completion column"
    // and the parent has incomplete subtasks, we must abort the drop entirely
    // so the card stays in its original column. Doing this BEFORE
    // transferArrayItem means there's nothing to revert on failure.
    // ----------------------------------------------------------------------
    const newColumnId = event.container.id;
    const draggedTask: any = event.previousContainer.data[event.previousIndex];

    const targetStatusId = this.getStatusIdForColumn(newColumnId);
    if (targetStatusId != null && this.taskService.isCompletionStatus(targetStatusId)) {
      const taskIdNum = this.toNumericTaskId(draggedTask?.task_id);
      const check = this.taskService.canCompleteTask(taskIdNum);
      if (!check.allowed) {
        this.dialogService.openSnackBar(check.message, 'OK');
        return; // exit before any UI mutation, before any API call
      }
    }

    // Validation passed — commit the drop visually (CDK requires this
    // synchronously inside the handler).
    transferArrayItem(
      event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );

    const task: any = event.container.data[event.currentIndex];
    // task.status now stores the numeric API id as a string. Snapshot for revert.
    const previousStatus = task.status;
    const previousStatusName = task?._raw?.task_status_name;

    // Resolve the target status ID and name from the loaded lookup list.
    const statusId = targetStatusId;
    const taskIdNum = this.toNumericTaskId(task.task_id);
    if (statusId == null || isNaN(taskIdNum)) {
      this.dialogService.openSnackBar('Failed to move case: invalid case id', 'OK');
      this.revertTaskToColumn(task, previousStatus, previousStatusName);
      return;
    }
    const newStatusName = this.taskService.getStatusNameById(statusId);

    // Optimistic update — commit the new id + name so distributeTasksToColumns
    // routes the card into the right column on the next render.
    task.status = String(statusId);
    if (task._raw) task._raw.task_status_name = newStatusName;
    const rowIdx = this.rowData.findIndex((t) => t.task_id === task.task_id);
    if (rowIdx !== -1) this.rowData[rowIdx] = { ...task };
    this.filteredRowData = [...this.rowData];

    const updateSub = this.taskService.updateTaskStatusApi({
      task_id: taskIdNum,
      task_status_id: statusId,
      updated_by: this.getCurrentUserName(),
    }).subscribe({
      next: () => {
        this.dialogService.openSnackBar('Case moved successfully', 'OK');
      },
      error: (err: any) => {
        this.revertTaskToColumn(task, previousStatus, previousStatusName);
        this.dialogService.openSnackBar(
          'Failed to move case: ' + (err?.message || 'Unknown error'),
          'OK'
        );
      },
    });
    this.reqSubcription.push(updateSub);
  }

  /** Look up the API task_status_id for a kanban column id. Fully dynamic —
   *  driven by the lookup list loaded into TaskMgmtService at startup. */
  private getStatusIdForColumn(columnId: string): number | null {
    const aliases: Record<string, string[]> = {
      'planned': ['open'],
      'in-progress': ['in progress', 'inprogress', 'in-progress'],
      'done': ['done', 'closed', 'complete', 'completed'],
      'cancelled': ['cancelled', 'canceled'],
    };
    const candidates = aliases[columnId] || [columnId];
    for (const name of candidates) {
      const id = this.taskService.getStatusIdByName(name);
      if (id != null) return id;
    }
    console.warn('No status ID found for kanban column:', columnId);
    return null;
  }

  /** Move a task back to its original column (revert in-place after a failed/cancelled drop). */
  private revertTaskToColumn(task: any, previousStatus: string, previousStatusName?: string): void {
    task.status = previousStatus;
    if (task._raw && previousStatusName !== undefined) {
      task._raw.task_status_name = previousStatusName;
    }
    const rowIdx = this.rowData.findIndex((t) => t.task_id === task.task_id);
    if (rowIdx !== -1) this.rowData[rowIdx] = { ...task };
    this.filteredRowData = [...this.rowData];
    this.distributeTasksToColumns();
  }

  /** Best-effort numeric conversion of a TaskModel.task_id ("T0123" → 123, "42" → 42). */
  private toNumericTaskId(id: string | null | undefined): number {
    if (id == null) return NaN;
    const n = parseInt(String(id).replace(/^T/i, ''), 10);
    return isNaN(n) ? NaN : n;
  }

  /** Resolve the current user display name (used for updated_by on status updates). */
  private getCurrentUserName(): string | null {
    const fromSession = this.sessionService?.getUsername?.();
    if (fromSession) return fromSession;
    try {
      const raw = sessionStorage.getItem("userInformation");
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed?.usr_display_nm || null;
    } catch {
      return null;
    }
  }

  /** Kanban-card click — opens the slide-in subtask sidebar. Thin wrapper
   *  around `openTaskSidebar` so both kanban card clicks and table row clicks
   *  share the same sidebar-opening path. */
  onKanbanCardClick(task: TaskModel): void {
    this.openTaskSidebar(task);
  }

  /** Shared sidebar opener — used by both `onKanbanCardClick` (kanban view)
   *  and `onRowClicked` (table view).
   *
   *  1. Shows the sidebar IMMEDIATELY with whatever is in the in-memory
   *     store (fast UX — no loading delay).
   *  2. Fires `getTaskByIdFromApi` in the background to refresh the task
   *     header (status, priority, assignees, etc.) with the latest server
   *     state. When the API responds, `sidebarTask` and the matching
   *     `rowData` entry are silently updated.
   *  3. Subtask data stays from the in-memory store, which is maintained
   *     locally on every create/edit/drag-drop — a full re-fetch would be
   *     the expensive `get-all-sub-tasks` endpoint and is not needed here. */
  private openTaskSidebar(task: TaskModel): void {
    // Embedded sidebar mode: clicking a main case must NOT open the subtask
    // sidebar (both kanban-card and table-row clicks funnel through here).
    if (this.sidebarMode) return;

    this.expandedTask = null;

    // --- Step 1: Cached data for instant rendering ---
    this.sidebarTask = task;
    this.sidebarOpen = true;
    this.isLoadingSidebarSubtasks = false;

    const numericId = this.toNumericTaskId(task.task_id);
    if (isNaN(numericId)) {
      this.sidebarSubtasks = [];
      this.isRefreshingSidebar = false;
      return;
    }

    const rawSubtasks = this.taskService.getSubtasksForParent(numericId);
    this.sidebarSubtasks = rawSubtasks.map((s) => this.mapStoreSubtaskToModel(s));

    // --- Step 2: Background API refresh for the task header ---
    // Cancel any in-flight refresh from a previous rapid open.
    if (this.sidebarRefreshSub) {
      this.sidebarRefreshSub.unsubscribe();
      this.sidebarRefreshSub = null;
    }

    this.isRefreshingSidebar = true;

    this.sidebarRefreshSub = this.taskService.getTaskByIdFromApi(numericId).subscribe({
      next: (response: any) => {
        const rawTask = response?.data ?? response;
        if (!rawTask) {
          this.isRefreshingSidebar = false;
          return;
        }

        // Route through updateTaskInStore so counts are preserved.
        const freshModel = this.taskService.updateTaskInStore(String(numericId), rawTask);

        this.sidebarTask = freshModel;

        const existing = this.rowData.find(
          (t) => this.toNumericTaskId(t.task_id) === numericId
        );
        const rowIdx = existing ? this.rowData.indexOf(existing) : -1;
        if (rowIdx !== -1) {
          this.rowData[rowIdx] = {
            ...freshModel,
            _subCount: existing!._subCount,
            _subDone: existing!._subDone,
          };
          this.filteredRowData = [...this.rowData];
          this.distributeTasksToColumns();
          this.refreshGridRow(numericId);
        }

        this.isRefreshingSidebar = false;
      },
      error: () => {
        // API failed — gracefully degrade, keep cached data.
        this.isRefreshingSidebar = false;
      },
    });
    this.reqSubcription.push(this.sidebarRefreshSub);
  }

  /** Sidebar `closed` handler. Cancels any in-flight background refresh so
   *  its stale response doesn't overwrite state after the sidebar is gone. */
  onSidebarClosed(): void {
    this.sidebarOpen = false;
    this.sidebarTask = null;
    this.sidebarSubtasks = [];
    this.isLoadingSidebarSubtasks = false;
    this.isRefreshingSidebar = false;
    if (this.sidebarRefreshSub) {
      this.sidebarRefreshSub.unsubscribe();
      this.sidebarRefreshSub = null;
    }
  }

  /** Sidebar `subtaskCreated` handler — push the created subtask into the in-memory
   *  store and refresh the sidebar list + kanban card progress bar locally. NO API. */
  onSidebarSubtaskCreated(createdSubtask: any): void {
    if (!createdSubtask) return;
    const item = createdSubtask?.data ?? createdSubtask;

    // If the API actually returned a populated task object, write it straight to the store.
    if (item && (item.task_id != null || item.id != null)) {
      const normalised = this.normaliseStoreSubtask(item);
      this.taskService.updateSubtaskInStore(normalised);
      this.refreshSidebarFromStore();
      this.attachSubtaskCounts();
      this.distributeTasksToColumns();
    } else {
      // TODO: Remove this full refresh once create API returns the complete subtask object.
      const refreshSub = this.taskService.refreshAllSubtasks().subscribe({
        next: () => {
          this.refreshSidebarFromStore();
          this.attachSubtaskCounts();
          this.distributeTasksToColumns();
        },
        error: () => {
          this.dialogService.openSnackBar('Failed to refresh subtasks.', 'OK');
        },
      });
      this.reqSubcription.push(refreshSub);
    }
  }

  /** Sidebar `subtaskUpdated` handler — replace in the in-memory store, refresh
   *  sidebar + kanban card. NO API. */
  onSidebarSubtaskUpdated(updatedSubtask: any): void {
    if (!updatedSubtask) return;
    const item = updatedSubtask?.data ?? updatedSubtask;
    if (!item || (item.task_id == null && item.id == null)) return;
    const normalised = this.normaliseStoreSubtask(item);
    this.taskService.updateSubtaskInStore(normalised);
    this.refreshSidebarFromStore();
    this.attachSubtaskCounts();
    this.distributeTasksToColumns();
  }

  /** Sidebar `subtaskStatusChanged` handler — drag-drop already persisted via the
   *  sidebar's own API call. Mirror the optimistic change into the in-memory store
   *  and refresh the parent kanban card progress bar. NO API call here. */
  onSidebarSubtaskStatusChanged(latestSubtasks: SubtaskModel[] | { subtask: any; newStatusId: number }): void {
    // Two payload shapes are tolerated:
    //   1) full SubtaskModel[] (current sidebar emit) — recompute store entries from it
    //   2) { subtask, newStatusId } (planned shape) — single-subtask in-place update
    if (Array.isArray(latestSubtasks)) {
      // Mirror each updated subtask back into the store so other consumers see the change.
      latestSubtasks.forEach((st) => {
        const numericId = this.toNumericTaskId(st.subtask_id);
        if (isNaN(numericId)) return;
        // st.status is now the numeric API id stored as a string.
        const statusId = st.status ? Number(st.status) : null;
        this.taskService.updateSubtaskInStore({
          task_id: numericId,
          parent_task_id: this.sidebarTask
            ? this.toNumericTaskId(this.sidebarTask.task_id)
            : undefined,
          task_status_id: statusId,
          task_name: st.name,
        });
      });
      this.sidebarSubtasks = [...latestSubtasks];
    } else if (latestSubtasks && typeof latestSubtasks === 'object') {
      const payload = latestSubtasks as { subtask: any; newStatusId: number };
      const updated = { ...payload.subtask, task_status_id: payload.newStatusId };
      this.taskService.updateSubtaskInStore(updated);
      this.refreshSidebarFromStore();
    }
    this.attachSubtaskCounts();
    this.distributeTasksToColumns();
  }

  /** Re-derive the sidebar's subtask list from the in-memory store. */
  private refreshSidebarFromStore(): void {
    if (!this.sidebarTask) return;
    const numericId = this.toNumericTaskId(this.sidebarTask.task_id);
    if (isNaN(numericId)) {
      this.sidebarSubtasks = [];
      return;
    }
    const raw = this.taskService.getSubtasksForParent(numericId);
    this.sidebarSubtasks = raw.map((s) => this.mapStoreSubtaskToModel(s));
  }

  /** Walk every task in `rowData` and populate `_subCount` / `_subDone` from the
   *  in-memory all-subtasks store. Pure local — no API. */
  private attachSubtaskCounts(): void {
    this.rowData = this.rowData.map((task) => {
      const numericId = this.toNumericTaskId(task.task_id);
      if (isNaN(numericId)) {
        return { ...task, _subCount: 0, _subDone: 0 };
      }
      const counts = this.taskService.getSubtaskCountsForParent(numericId);
      return { ...task, _subCount: counts.total, _subDone: counts.done };
    });
    this.filteredRowData = [...this.rowData];
  }

  /** Lightly normalise a raw API subtask object before writing it into the store
   *  (ensures `task_id` and `parent_task_id` are numbers and the status id is set). */
  private normaliseStoreSubtask(item: any): any {
    if (!item) return item;
    const out = { ...item };
    if (out.task_id == null && out.id != null) out.task_id = out.id;
    if (typeof out.task_id === 'string') {
      const n = parseInt(out.task_id, 10);
      if (!isNaN(n)) out.task_id = n;
    }
    if (typeof out.parent_task_id === 'string') {
      const n = parseInt(out.parent_task_id, 10);
      if (!isNaN(n)) out.parent_task_id = n;
    }
    return out;
  }

  /** Convert a raw store-shaped subtask (snake_case from the API) into a SubtaskModel.
   *  status / priorityLevel / taskType hold the numeric API id as a string; the
   *  raw API payload is preserved on `(model as any)._raw` so the sidebar can
   *  read task_status_name / task_priority_name / task_type_name directly. */
  private mapStoreSubtaskToModel(item: any): SubtaskModel {
    const statusIdStr = item?.task_status_id != null ? String(item.task_status_id) : '';
    const priorityIdStr = item?.task_priority_id != null ? String(item.task_priority_id) : '';
    const typeIdStr = item?.task_type_id != null ? String(item.task_type_id) : '';

    let assignTo: string = item?.owner_id ?? item?.assignTo ?? '';
    if (!assignTo && Array.isArray(item?.assignees) && item.assignees.length) {
      assignTo = item.assignees[0]?.assignee_email ?? item.assignees[0]?.email ?? '';
    }
    if (!assignTo && Array.isArray(item?.assignee_emails) && item.assignee_emails.length) {
      assignTo = item.assignee_emails[0] ?? '';
    }

    const model: any = {
      subtask_id: item?.task_id != null ? String(item.task_id)
        : (item?.id != null ? String(item.id) : ''),
      name: (item?.task_name ?? item?.name ?? '').toString().trim(),
      taskType: typeIdStr,
      startDate: item?.start_date ?? item?.startDate ?? null,
      endDate: item?.end_date ?? item?.endDate ?? null,
      remindMe: false,
      remindDate: null,
      remindTime: null,
      priorityLevel: priorityIdStr,
      status: statusIdStr,
      assignTo,
      tagType: item?.tagType ?? '',
      tags: Array.isArray(item?.tags) ? item.tags : (Array.isArray(item?.tag_ids) ? item.tag_ids : []),
      description: (item?.description ?? '').toString().trim(),
      attachments: [],
      comments: [],
      _commentCount: item?.comment_count ?? 0,
      _attachmentCount: item?.attachment_count ?? 0,
      _raw: item,
    };
    return model as SubtaskModel;
  }

  /** Resolve a task's task type display name. Prefers `_raw.task_type_name`
   *  (which the API supplies alongside the id), then falls back to a lookup
   *  against `taskTypeOptions`. */
  getTaskTypeName(task: any): string {
    if (!task) return '';
    const rawName = task?._raw?.task_type_name;
    if (rawName) return rawName;
    const id = task.taskType ?? task.task_type_id;
    if (id == null || id === '') return '';
    const numericId = Number(id);
    const match = (this.taskTypeOptions || []).find(
      (t: any) => t.value === numericId || t.value === id
    );
    return match ? match.label : '';
  }

  /** Resolve a task's status display name (prefers `_raw.task_status_name`). */
  getStatusName(task: any): string {
    if (!task) return '';
    const rawName = task?._raw?.task_status_name;
    if (rawName) return rawName;
    const id = task.status ?? task.task_status_id;
    if (id == null || id === '') return '';
    return this.taskService.getStatusNameById(Number(id));
  }

  /** Resolve a task's priority display name. */
  getPriorityName(task: any): string {
    if (!task) return '';
    const rawName = task?._raw?.task_priority_name;
    if (rawName) return rawName;
    const id = task.priorityLevel ?? task.task_priority_id;
    if (id == null || id === '') return '';
    return this.taskService.getPriorityNameById(Number(id));
  }

  /** Map a priority name to a CSS class for the kanban-card chip. */
  getPriorityClass(task: any): string {
    const name = this.getPriorityName(task).toLowerCase();
    if (name === 'high') return 'tmwf-priority-high';
    if (name === 'medium') return 'tmwf-priority-medium';
    if (name === 'low') return 'tmwf-priority-low';
    return 'tmwf-priority-default';
  }

  /** Return the assignee email list for a task, tolerating multiple shapes:
   *  - `task.assignees: [{ assignee_email }]`
   *  - `task.assignee_emails: string[]`
   *  - legacy `task.assignTo: string` */
  getAssignees(task: any): string[] {
    if (!task) return [];
    if (Array.isArray(task.assignees) && task.assignees.length) {
      return task.assignees
        .map((a: any) => (typeof a === 'string' ? a : (a?.assignee_email || a?.email)))
        .filter((e: any) => !!e);
    }
    if (Array.isArray(task.assignee_emails) && task.assignee_emails.length) {
      return task.assignee_emails.filter((e: any) => !!e);
    }
    if (task.assignTo) return [task.assignTo];
    return [];
  }

  /** Initials from an email address — `john.doe@example.com` → `JD`. */
  getInitials(email: string | null | undefined): string {
    if (!email) return '?';
    const prefix = email.split('@')[0] || email;
    const parts = prefix.split(/[._\-+]/).filter((p) => p.length > 0);
    const first = (parts[0]?.[0] || '').toUpperCase();
    const second = (parts[1]?.[0] || parts[0]?.[1] || '').toUpperCase();
    return (first + second) || '?';
  }

  /** Format an ISO date as "DD Mmm YYYY" for the kanban-card "Due" line. */
  formatDueDate(iso: string | null | undefined): string {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  /** A task is overdue when its end date is in the past AND it isn't done/cancelled. */
  isOverdue(task: any): boolean {
    if (!task?.endDate) return false;
    const colId = this.getColumnForTask(task);
    if (colId === 'done' || colId === 'cancelled') return false;
    const end = new Date(task.endDate);
    if (isNaN(end.getTime())) return false;
    return end.getTime() < Date.now();
  }

  /** Return only the tag entries that are full objects with `category_name`.
   *  TaskModel.tags is currently number[] (the service mapper truncates), so this
   *  is effectively a no-op until the API mapper preserves the rich tag shape.
   *  TODO: Resolve tag IDs to names once tag lookup is wired through TaskMgmtService. */
  getEntityTags(task: TaskModel | null | undefined): any[] {
    const raw: any = task?.tags;
    if (!Array.isArray(raw)) return [];
    return raw.filter((t: any) => t && typeof t === 'object' && t.category_name);
  }

  getPriorityColor(priority: string): string {
    return this.priorityColors[priority]?.text || "#374151";
  }

  getPriorityBorderColor(priority: string): string {
    return this.priorityColors[priority]?.border || "#d1d5db";
  }

  // --------------------------------------------------------
  //  Subtask Helpers
  // --------------------------------------------------------

  hasSubtasks(task: TaskModel): boolean {
    return (task?._subCount ?? 0) > 0;
  }

  getSubtaskTooltip(task: TaskModel): string {
    const total = task?._subCount ?? 0;
    if (total <= 0) return '';
    const done = task?._subDone ?? 0;
    return `This case contains ${total} subtask(s) (${done} completed)`;
  }

  // --------------------------------------------------------
  //  Drill-down Panel Handlers
  // --------------------------------------------------------

  onDrilldownCollapsed(): void {
    this.expandedTask = null;
  }

  onSubtaskDropConfirmNeeded(payload: SubtaskDropConfirmPayload): void {
    const { subtask, parentTask, previousStatus, newStatus } = payload;

    const dialogRef = this.dialog.open(TaskManagementDialogComponent, {
      width: "80vw",
      maxWidth: "700px",
      data: {
        ...subtask,
        task_id: subtask.subtask_id,
        taskName: subtask.name,
        status: newStatus,
        initialTab: 1,
        dragTargetStatus: newStatus,
        isSubtask: true,
      },
    });

    const dialogSub = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // User confirmed — commit the status change
        subtask.status = newStatus;
        Object.assign(subtask, {
          name: result.taskName || result.name || subtask.name,
          ...result,
          subtask_id: subtask.subtask_id,
          status: newStatus,
        });

        const rowIdx = this.rowData.findIndex(t => t.task_id === parentTask.task_id);
        if (rowIdx !== -1) {
          this.rowData[rowIdx] = { ...parentTask };
        }
        this.filteredRowData = [...this.rowData];
        this.distributeTasksToColumns();
        this.expandedTask = { ...parentTask };

        const updateSub = this.taskService.updateTask(parentTask).subscribe({
          next: () => this.dialogService.openSnackBar('Subtask status updated.', 'OK'),
          error: () => this.dialogService.openSnackBar('Failed to update subtask.', 'OK'),
        });
        this.reqSubcription.push(updateSub);
      } else {
        // User cancelled — revert by re-assigning expandedTask (triggers ngOnChanges → distributeSubtasks)
        this.expandedTask = { ...parentTask };
      }
    });
    this.reqSubcription.push(dialogSub);
  }

  onSubtaskStatusChanged(updatedTask: TaskModel): void {
    const rowIdx = this.rowData.findIndex(t => t.task_id === updatedTask.task_id);
    if (rowIdx !== -1) this.rowData[rowIdx] = updatedTask;
    this.filteredRowData = [...this.rowData];
    this.distributeTasksToColumns();
    this.expandedTask = updatedTask;

    const updateSub = this.taskService.updateTask(updatedTask).subscribe({
      error: () => this.dialogService.openSnackBar('Failed to update subtask.', 'OK'),
    });
    this.reqSubcription.push(updateSub);
  }

  // --------------------------------------------------------
  //  Create Case
  // --------------------------------------------------------

  /** Convenience: returns the lookup options that should be merged into every
   *  TaskManagementDialogComponent open call so the form can render dropdowns. */
  private getDialogLookupOptions(): any {
    return {
      statusOptions: this.statusOptions,
      priorityOptions: this.priorityOptions,
      taskTypeOptions: this.taskTypeOptions,
      tagCategories: this.tagCategories,
      categoryIdCache: this.categoryIdCache,
      // Sentinel that lets the detail dialog tell "API responded with []" from
      // "haven't loaded yet" — without this the skeleton would never hide for
      // an account that genuinely has no tag categories.
      _tagCategoriesLoaded: this.isStartupComplete,
    };
  }

  /** Resolve a tag_category_id to its category_name via the loaded
   *  tagCategories lookup (e.g. 1 → "Patient", 2 → "Prescriber"). Returns ''
   *  if the id isn't found so callers can fall back gracefully. */
  private resolveTagCategoryName(categoryId: any): string {
    const match = this.tagCategories.find(
      (c: any) => Number(c?.tag_category_id) === Number(categoryId)
    );
    return String(match?.category_name || '');
  }

  onCreateTaskClick(columnKeyOverride?: string, lockStatus: boolean = false): void {
    if (this.isCreateDialogOpen) return;
    this.isCreateDialogOpen = true;

    // Collapse drill-down panel before dialog
    this.expandedTask = null;

    const baseDate = new Date();

    // Resolve the preset status as a numeric API id via the loaded status list.
    // Default create → "Open". Column-spawned create → that column's status.
    // Never hardcoded — the API IDs can change between environments.
    const presetStatusId: number | null = columnKeyOverride
      ? this.taskService.getStatusIdByColumnKey(columnKeyOverride)
      : this.taskService.getDefaultOpenStatusId();

    // When the board is embedded in the entity sidebar (opened from a patient /
    // prescriber grid row), the new case must be tagged to that entity. Seed the
    // dialog's tag chip + entity from tagContext: the type chip is pre-selected
    // AND locked, and the entity is auto-filled. restoreTagsFromTaskData() in the
    // dialog reads these rich tag objects to hydrate the chip/entity state.
    const tc = this.tagContext;
    const hasPresetTag = this.sidebarMode && tc && tc.tag_id != null;
    const presetTags = hasPresetTag
      ? [{
          tag_id: tc!.tag_id,
          tag_name: String(tc!.tag_name ?? tc!.tag_id),
          tag_category_id: tc!.tag_category_id,
          category_name: this.resolveTagCategoryName(tc!.tag_category_id),
        }]
      : [];

    const initialTaskData = {
      mode: 'create',
      taskName: "",
      taskType: null,
      assignees: [],
      startDate: baseDate,
      endDate: baseDate,
      remindMe: false,
      remindDate: null,
      // Numeric API id — matches mat-option [value] (also a number) so the
      // select auto-selects on render. See task-detail-content.applyInitialStatus.
      presetStatusId,
      lockStatus,
      priorityLevel: null,
      tagType: hasPresetTag ? tc!.tag_category_id : null,
      tags: presetTags,
      // Lock the tag-type chip when the entity context is preset so the case
      // can't be re-tagged to a different entity type.
      lockTagType: hasPresetTag,
      description: "",
      taskStatus: false,
      isCancelled: false,
      subtasks: [],
    };

    const dialogRef = this.dialog.open(TaskManagementDialogComponent, {
      width: "80vw",
      maxWidth: "700px",
      autoFocus: false,
      data: { ...initialTaskData, ...this.getDialogLookupOptions() },
    });

    const dialogSub = dialogRef.afterClosed().subscribe((result) => {
      this.isCreateDialogOpen = false;
      if (!result) return;

      const addSub = this.taskService.addTask(result).subscribe({
        next: (newTask: any) => {
          this.rowData = [...this.rowData, newTask];
          this.filteredRowData = [...this.rowData];
          this.distributeTasksToColumns();
          this.dialogService.openSnackBar("Case created successfully.", "OK");
        },
        error: () => {
          this.dialogService.openSnackBar("Failed to create case.", "OK");
        },
      });
      this.reqSubcription.push(addSub);
    });
    this.reqSubcription.push(dialogSub);
  }

  /** Per-column "+" button handler — opens create with status preset to the
   *  clicked column's status AND locked (user cannot change it). */
  onCreateTaskInColumn(columnKey: string): void {
    this.onCreateTaskClick(columnKey, true);
  }

  onCreateSubtaskForParent(parentTask: TaskModel): void {
    const baseDate = new Date();
    const initialSubtaskData = {
      taskName: '',
      taskType: null,
      assignees: [],
      startDate: baseDate,
      endDate: baseDate,
      remindMe: false,
      remindDate: null,
      status: 'planned',
      priorityLevel: 'medium',
      tagType: null,
      tags: [],
      description: '',
      taskStatus: false,
      isCancelled: false,
      isSubtask: true,
      subtasks: [],
      parentTaskInfo: {
        taskName: parentTask.taskName,
        taskType: parentTask.taskType,
        status: parentTask.status,
        priorityLevel: parentTask.priorityLevel,
        assignTo: parentTask.assignTo,
        task_id: parentTask.task_id,
      },
    };

    const dialogRef = this.dialog.open(TaskManagementDialogComponent, {
      width: '80vw',
      maxWidth: '700px',
      autoFocus: false,
      data: { ...initialSubtaskData, ...this.getDialogLookupOptions() },
    });

    const dialogSub = dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;

      const newSubtask: SubtaskModel = {
        subtask_id: 'ST' + Date.now(),
        name: result.taskName,
        taskType: result.taskType || '',
        startDate: result.startDate,
        endDate: result.endDate,
        remindMe: result.remindMe,
        remindDate: result.remindDate,
        remindTime: null,
        priorityLevel: result.priorityLevel,
        status: result.status || 'planned',
        assignTo: result.assignTo || '',
        tagType: result.tagType || '',
        tags: result.tags || [],
        description: result.description || '',
        attachments: result.attachments || [],
        comments: [],
      };

      if (!parentTask.subtasks) parentTask.subtasks = [];
      parentTask.subtasks = [...parentTask.subtasks, newSubtask];

      const updateSub = this.taskService.updateTask(parentTask).subscribe({
        next: () => {
          this.filteredRowData = [...this.rowData];
          this.distributeTasksToColumns();
          this.expandedTask = { ...parentTask };
        },
        error: () => {
          this.dialogService.openSnackBar('Subtask created but parent case update failed.', 'OK');
        },
      });
      this.reqSubcription.push(updateSub);
    });
    this.reqSubcription.push(dialogSub);
  }

  // --------------------------------------------------------
  //  AG-Grid: Setup & Actions
  // --------------------------------------------------------

  private setupGridColumns(): void {
    const momentDateFormatter = (params: any) => {
      if (!params.value) return "- -";
      const m = moment(params.value);
      if (!m.isValid()) return "- -";
      const hasTime = m.hours() !== 0 || m.minutes() !== 0;
      return hasTime
        ? m.format("MMMM DD, YYYY, hh:mmA")
        : m.format("MMMM DD, YYYY");
    };

    this.columnDefs = [
      {
        headerName: "CASE NAME",
        field: "taskName",
        minWidth: 140,
        cellRenderer: 'agGroupCellRenderer',
      },
      {
        headerName: "START DATE",
        field: "startDate",
        valueFormatter: momentDateFormatter,
        minWidth: 180,
      },
      {
        headerName: "END DATE",
        field: "endDate",
        valueFormatter: momentDateFormatter,
        minWidth: 180,
      },
      {
        headerName: "ASSIGNEES",
        field: "assignTo",
        cellRenderer: "avatarCellRenderer",
        minWidth: 120,
        sortable: false,
      },
      {
        headerName: "TASK OWNER",
        field: "assignTo",
        cellRenderer: "avatarCellRenderer",
        minWidth: 120,
        sortable: false,
      },
      {
        headerName: "STATUS",
        field: "status",
        cellRenderer: "statusCellRenderer",
        minWidth: 120,
        valueGetter: (params: any) =>
          params.data?._raw?.task_status_name
          || this.taskService.getStatusNameById(Number(params.data?.status))
          || '',
      },
      {
        headerName: "PRIORITY",
        field: "priorityLevel",
        cellRenderer: "priorityCellRenderer",
        minWidth: 100,
        valueGetter: (params: any) =>
          params.data?._raw?.task_priority_name
          || this.taskService.getPriorityNameById(Number(params.data?.priorityLevel))
          || '',
      },
      {
        // Row action icons (Edit / Comments / Attachments). The renderer
        // bridges clicks back to `this.onEditTask(data, 0|1|2)` via the grid
        // `context.componentParent`. `field: 'actions'` is the sentinel that
        // `onRowClicked` checks so row clicks on this column do not also
        // open the subtask sidebar.
        headerName: '',
        field: 'actions',
        maxWidth: 110,
        minWidth: 110,
        sortable: false,
        suppressMenu: true,
        cellRenderer: 'actionsCellRenderer',
        cellStyle: {
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          gap: '4px',
        },
      },
    ];
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.onPaginationChanged();
  }

  /** Force a single grid row to re-render (e.g. after a count badge update).
   *  applyTransaction pushes the new data object into the row node so that
   *  the cell renderer's refresh(params) receives fresh params.data.
   *  refreshCells with force then triggers the actual re-render. */
  private refreshGridRow(taskId: string | number): void {
    if (!this.gridApi) return;
    const stringId = String(taskId);
    const rowNode = this.gridApi.getRowNode(stringId);
    if (!rowNode) return;
    const rowIdx = this.filteredRowData.findIndex(t => String(t.task_id) === stringId);
    if (rowIdx >= 0) {
      this.gridApi.applyTransaction({ update: [this.filteredRowData[rowIdx]] });
    }
    this.gridApi.refreshCells({ rowNodes: [rowNode], force: true });
  }

  /** Update comment/attachment counts on a single task in both rowData and
   *  filteredRowData, then refresh the kanban columns and grid row. */
  private updateTaskCountInRowData(event: { taskId: number; commentCount?: number; attachmentCount?: number }): void {
    const idx = this.rowData.findIndex(t => this.toNumericTaskId(t.task_id) === event.taskId);
    if (idx < 0) return;

    const task = this.rowData[idx];
    const updated = { ...task, _raw: task._raw ? { ...task._raw } : undefined };
    if (event.commentCount !== undefined) {
      updated._commentCount = event.commentCount;
      if (updated._raw) updated._raw.comment_count = event.commentCount;
    }
    if (event.attachmentCount !== undefined) {
      updated._attachmentCount = event.attachmentCount;
      if (updated._raw) updated._raw.attachment_count = event.attachmentCount;
    }
    this.rowData[idx] = updated;

    const filtIdx = this.filteredRowData.findIndex(t => this.toNumericTaskId(t.task_id) === event.taskId);
    if (filtIdx >= 0) {
      this.filteredRowData[filtIdx] = updated;
      this.filteredRowData = [...this.filteredRowData];
    }

    this.distributeTasksToColumns();
    this.refreshGridRow(event.taskId);
  }

  onGridSearchChange(): void {
    if (!this.searchText.trim()) {
      this.filteredRowData = [...this.rowData];
      this.distributeTasksToColumns();
      return;
    }
    const term = this.searchText.toLowerCase();
    this.filteredRowData = this.rowData.filter(
      (t) =>
        (t.taskName || "").toLowerCase().includes(term) ||
        (t.assignTo || "").toLowerCase().includes(term) ||
        (t.status || "").toLowerCase().includes(term)
    );
    this.distributeTasksToColumns();
  }

  /** Read the per-task comment count without depending on TaskModel having
   *  a `_commentCount` field. Templates can't safely access untyped fields,
   *  so we expose a typed helper that future API plumbing can populate.
   *  Returns 0 until that wiring lands. */
  getCommentCount(task: any): number {
    const c = task?._commentCount ?? task?._raw?.comment_count;
    return typeof c === 'number' && c > 0 ? c : 0;
  }

  /** Kanban-card edit pencil (top-right), comment icon and attachment icon
   *  (end of due-date row). All three route through the same refresh-then-open
   *  flow so the dialog always shows the freshest server-side state.
   *
   *  `initialTab` lands the dialog directly on the corresponding tab via the
   *  existing `initialTab` data prop (handled by TaskDetailContentComponent
   *  ngOnInit):
   *     0 → Task Details
   *     1 → Task Updates
   *     2 → Attachments */
  onEditTask(task: TaskModel, initialTab: number = 0): void {
    this.refreshAndOpenEditDialog(task, initialTab, false);
  }

  /** AG-Grid table row click. Now opens the subtask sidebar (same behaviour
   *  as the kanban card click) instead of the main task dialog. Dialog edits
   *  are still reachable from the row via the Actions column's icon buttons.
   *
   *  Guards against a direct click on the Actions column so the row-level
   *  listener does not also fire alongside the action button's own handler.
   *  (The buttons already stopPropagation, but ag-grid can still surface
   *  cell clicks for the underlying row — belt-and-braces check.) */
  onRowClicked(event: any): void {
    if (!event?.data) return;
    const colId = event.column?.getColId?.() ?? event.colDef?.field;
    if (colId === 'actions') return;
    this.openTaskSidebar(event.data as TaskModel);
  }

  /** Called by ActionsCellRendererComponent when an action icon is clicked on a
   *  SUBTASK row in the detail grid. Opens the subtask sidebar for the parent
   *  task, then opens the subtask edit dialog on the requested tab. */
  onSubtaskActionFromGrid(subtaskRow: any, tab: 'details' | 'updates' | 'attachments'): void {
    if (!subtaskRow) return;

    const parentTaskIdNum = Number(subtaskRow.parent_task_id);
    if (isNaN(parentTaskIdNum)) return;

    const parentTask = this.rowData.find(
      (t) => this.toNumericTaskId(t.task_id) === parentTaskIdNum
    );
    if (!parentTask) return;

    this.openTaskSidebar(parentTask);

    const subtaskModel = this.mapStoreSubtaskToModel(subtaskRow);
    setTimeout(() => {
      this.subtaskPanel?.openSubtaskEditFromExternal(subtaskModel, tab);
    }, 0);
  }

  /** Read the per-task attachment count. Prefers the new `_attachmentCount`
   *  field that mapApiResponseToTaskModel populates from
   *  `attachment_count` on the get-all response, then falls back to the
   *  legacy `_raw.attachments` array shape for backwards compatibility.
   *  TODO: Update _attachmentCount in real-time after attachment uploads /
   *  deletes in the Attachments tab. */
  getAttachmentCount(task: any): number {
    const direct = task?._attachmentCount ?? task?._raw?.attachment_count;
    if (typeof direct === 'number' && direct > 0) return direct;
    const raw = task?._raw?.attachments;
    if (Array.isArray(raw)) return raw.length;
    return 0;
  }

  /** Fetch the latest task data from `api/tasks/get-by-id` BEFORE opening the
   *  edit dialog so the form always reflects the freshest server-side state.
   *
   *  - On success: maps the raw API response into a TaskModel via the existing
   *    `mapApiResponseToTaskModel`, mirrors it into `rowData` (so the kanban
   *    card refreshes immediately even before the dialog closes), and opens
   *    the dialog with the fresh model.
   *  - On error / network failure: falls back to the in-memory `task` so the
   *    user can still open the dialog, plus a snackbar so they know the data
   *    might be stale.
   *  - A `pendingEditTaskId` guard ignores stale responses if the user clicks
   *    another task before this one resolves. */
  private refreshAndOpenEditDialog(task: TaskModel, initialTab: number, fromTableView: boolean): void {
    if (this.isEditDialogOpen) return;
    this.isEditDialogOpen = true;

    const taskIdNum = this.toNumericTaskId(task?.task_id);
    if (isNaN(taskIdNum)) {
      this.openEditDialogInternal(task, initialTab, fromTableView);
      return;
    }

    this.pendingEditTaskId = taskIdNum;

    const sub = this.taskService.getTaskByIdFromApi(taskIdNum).subscribe({
      next: (response: any) => {
        // Drop stale responses (user already clicked something else).
        if (this.pendingEditTaskId !== taskIdNum) return;
        this.pendingEditTaskId = null;

        const rawTask = response?.data ?? response;
        if (!rawTask) {
          this.openEditDialogInternal(task, initialTab, fromTableView);
          return;
        }

        // Route through updateTaskInStore so the service's tasks$ store
        // and the component's rowData stay in sync with preserved counts.
        const freshModel = this.taskService.updateTaskInStore(String(taskIdNum), rawTask);

        const existing = this.rowData.find(
          (t) => this.toNumericTaskId(t.task_id) === taskIdNum
        );
        const rowIdx = existing ? this.rowData.indexOf(existing) : -1;
        if (rowIdx !== -1) {
          this.rowData[rowIdx] = {
            ...freshModel,
            _subCount: existing!._subCount,
            _subDone: existing!._subDone,
          };
          this.filteredRowData = [...this.rowData];
          this.distributeTasksToColumns();
          this.refreshGridRow(taskIdNum);
        }

        this.openEditDialogInternal(freshModel, initialTab, fromTableView);
      },
      error: () => {
        if (this.pendingEditTaskId !== taskIdNum) return;
        this.pendingEditTaskId = null;
        this.openEditDialogInternal(task, initialTab, fromTableView);
        this.dialogService.openSnackBar('Could not refresh case data — showing cached version.', 'OK');
      },
    });
    this.reqSubcription.push(sub);
  }

  /** Actually open the TaskManagementDialogComponent and wire the
   *  afterClosed handler. Extracted so refreshAndOpenEditDialog can call it
   *  from BOTH the success and error paths without duplicating the open +
   *  completion-block + update logic. */
  private openEditDialogInternal(task: any, initialTab: number, fromTableView: boolean): void {
    const dialogRef = this.dialog.open(TaskManagementDialogComponent, {
      width: "80vw",
      maxWidth: "700px",
      // minHeight keeps the dialog at a stable size when the user toggles
      // between Details / Updates / Attachments tabs (Updates can be short
      // when empty, and the Attachments empty state is compact too). Pairs
      // with the same min-height on .task-detail-content-root in the SCSS
      // for safety.
      minHeight: "550px",
      data: {
        ...task,
        taskStatus: true,
        fromTableView,
        initialTab,
        // In sidebar mode the board is scoped to a single entity (patient/HCP),
        // so editing a case must NOT allow re-tagging it to a different entity
        // type — lock the tag-type chip + search + entity remove, same as create.
        lockTagType: this.sidebarMode,
        ...this.getDialogLookupOptions(),
      },
    });

    const dialogSub = dialogRef.afterClosed().subscribe((result) => {
      this.isEditDialogOpen = false;
      if (!result) return;

      // Block completion when any subtasks are still incomplete (synchronous,
      // no extra API call — mirrors the same guard in onTaskDrop).
      const newStatusId = result.status != null ? Number(result.status) : null;
      if (newStatusId != null && this.taskService.isCompletionStatus(newStatusId)) {
        const taskIdNum = this.toNumericTaskId(task.task_id);
        const check = this.taskService.canCompleteTask(taskIdNum);
        if (!check.allowed) {
          this.dialogService.openSnackBar(check.message, 'OK');
          return;
        }
      }

      const updateSub = this.taskService
        .updateTask({ ...result, task_id: task.task_id })
        .subscribe({
          next: (updated: any) => {
            const rowIdx = this.rowData.findIndex((t) => t.task_id === task.task_id);
            if (rowIdx !== -1) {
              const existing = this.rowData[rowIdx];
              this.rowData[rowIdx] = {
                ...updated,
                _commentCount: existing?._commentCount ?? updated?._commentCount ?? 0,
                _attachmentCount: existing?._attachmentCount ?? updated?._attachmentCount ?? 0,
                _subCount: existing?._subCount ?? 0,
                _subDone: existing?._subDone ?? 0,
              };
              if (this.rowData[rowIdx]._raw) {
                this.rowData[rowIdx]._raw.comment_count = this.rowData[rowIdx]._commentCount;
                this.rowData[rowIdx]._raw.attachment_count = this.rowData[rowIdx]._attachmentCount;
              }
            }
            this.filteredRowData = [...this.rowData];
            this.distributeTasksToColumns();
            this.refreshGridRow(task.task_id);
            this.dialogService.openSnackBar('Case updated', 'OK');
          },
          error: () => {
            this.dialogService.openSnackBar('Failed to save case changes. Please try again.', 'OK');
          },
        });
      this.reqSubcription.push(updateSub);
    });
    this.reqSubcription.push(dialogSub);
  }

  // --------------------------------------------------------
  //  Pagination
  // --------------------------------------------------------

  onPaginationChanged(): void {
    if (!this.gridApi) return;
    this.currentPage = this.gridApi.paginationGetCurrentPage();
    this.totalPages = this.gridApi.paginationGetTotalPages();
    this.updateVisiblePages();
  }

  onPageSizeChange(newSize: number): void {
    this.paginationPageSize = newSize;
    if (this.gridApi) {
      this.gridApi.paginationSetPageSize(newSize);
    }
  }

  goToPage(page: number): void {
    if (this.gridApi && page >= 0 && page < this.totalPages) {
      this.gridApi.paginationGoToPage(page);
    }
  }

  private updateVisiblePages(): void {
    const pages: (number | string)[] = [];
    const total = this.totalPages;
    const current = this.currentPage + 1;

    if (total <= 7) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      pages.push(1);
      if (current > 3) pages.push('...');

      const start = Math.max(2, current - 1);
      const end = Math.min(total - 1, current + 1);
      for (let i = start; i <= end; i++) pages.push(i);

      if (current < total - 2) pages.push('...');
      pages.push(total);
    }
    this.visiblePages = pages;
  }
}
